import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, ReplaySubject, tap } from 'rxjs';
import { Navigation } from 'app/core/models/navigation.model';
import { UserService } from './user.service';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  private _navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);

  /**
   * Constructor
   */
  constructor(
    private _httpClient: HttpClient,
    private user$: UserService
  ) {
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Getter for navigation
   */
  get navigation$(): Observable<Navigation> {
    let user;
    this.user$.user$.subscribe(u => {
      user = u;
    });
    return this._navigation.asObservable().pipe(map(n => ({
      default: [
        ...n.default.filter(f => !f.meta.isAdmin || (f.meta.isAdmin && user.isAdmin))
      ],
      compact: [
        ...n.compact.filter(f => !f.meta.isAdmin || (f.meta.isAdmin && user.isAdmin))
      ],
      futuristic: n.futuristic,
      horizontal: n.horizontal
    })));
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Get all navigation data
   */
  get(): Observable<Navigation> {
    return this._httpClient.get<Navigation>('api/common/navigation').pipe(
      tap((navigation) => {
        this._navigation.next(navigation);
      })
    );
  }
}
